(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cstm-bf-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cstm-bf-countdown')) {
    customElements.define('cstm-bf-countdown', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        const timer = this.querySelector('[data-cstm-timer]');
        if (!timer) return;
        const value = this.dataset.deadline || '';
        const deadline = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
        const invalid = this.querySelector('[data-cstm-date-error]');
        if (!Number.isFinite(deadline)) {if (invalid) invalid.hidden = false; return;}
        const update = () => {
          const ms = Math.max(0, deadline - Date.now());
          timer.hidden = ms === 0 && this.dataset.expiry === 'message';
          this.querySelector('[data-cstm-end]').hidden = ms > 0 || this.dataset.expiry !== 'message';
          this.querySelector('[data-cstm-days]').textContent = String(Math.floor(ms / 86400000));
          this.querySelector('[data-cstm-hours]').textContent = String(Math.floor(ms / 3600000) % 24).padStart(2, '0');
          this.querySelector('[data-cstm-minutes]').textContent = String(Math.floor(ms / 60000) % 60).padStart(2, '0');
          if (ms === 0) this.stop();
        };
        this.interval = setInterval(update, 1000);
        update();
      }
      stop() {clearInterval(this.interval);}
      disconnectedCallback() {this.stop();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-bf-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cstm-bf-products')) {
    customElements.define('cstm-bf-products', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.grid = this.querySelector('[data-cstm-grid]');
        this.status = this.querySelector('[data-cstm-status]');
        this.page = 1;
        this.brand = '';
        this.addEventListener('click', event => {
          const pill = event.target.closest('[data-cstm-brand]');
          if (pill) {this.brand = pill.dataset.cstmBrand; this.page = 1; this.apply();}
          if (event.target.closest('[data-cstm-prev]')) {this.page--; this.apply(true);}
          if (event.target.closest('[data-cstm-next]')) {this.page++; this.apply(true);}
          if (event.target.closest('[data-cstm-retry]')) this.load(true);
        }, {signal});
        this.querySelector('[data-cstm-sort]').addEventListener('change', () => {this.page = 1; this.apply();}, {signal});
        this.addEventListener('submit', event => {
          if (event.target.matches('[data-cstm-add]')) {event.preventDefault(); this.add(event.target);}
        }, {signal});
        if (this.cards) {this.buildPills(); this.apply();} else {this.load(false);}
      }
      disconnectedCallback() {this.controller?.abort(); this.controller = null; this.loading = false;}
      pageURL(value) {
        const url = new URL(value || location.href, location.href);
        if (url.origin !== location.origin) throw new Error('Invalid origin');
        url.searchParams.set('section_id', this.dataset.sectionId);
        return url;
      }
      async fetchPage(value) {
        const response = await fetch(this.pageURL(value), {signal:this.controller.signal, credentials:'same-origin', cache:'no-store'});
        if (!response.ok) throw new Error('Section unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const root = doc.getElementById(this.id);
        if (!root?.querySelector('[data-cstm-page]')) throw new Error('Section missing');
        return root;
      }
      async load(reset) {
        if (this.loading) return;
        this.loading = true;
        const controller = this.controller;
        this.querySelector('[data-cstm-retry]').hidden = true;
        this.querySelectorAll('[data-cstm-controls],[data-cstm-pills]').forEach(node => node.hidden = true);
        this.status.hidden = false;
        this.setAttribute('aria-busy','true');
        try {
          let source = this;
          if (reset || this.querySelector('[data-cstm-page]').dataset.page !== '1') {
            const first = this.pageURL(); first.searchParams.set('page','1'); source = await this.fetchPage(first);
          }
          const all = new Map();
          const seen = new Set();
          for (;;) {
            const info = source.querySelector('[data-cstm-page]');
            const sourceURL = this.pageURL(); sourceURL.searchParams.set('page',info.dataset.page);
            source.querySelectorAll('[data-cstm-card]').forEach(card => {
              card.dataset.sourceUrl = sourceURL.href;
              if (!all.has(card.dataset.id)) all.set(card.dataset.id, card);
            });
            if (!info.dataset.next) break;
            const next = this.pageURL(info.dataset.next).href;
            if (seen.has(next)) throw new Error('Pagination repeated');
            seen.add(next);
            source = await this.fetchPage(next);
            if (this.controller !== controller) return;
          }
          if (!this.isConnected || this.controller !== controller) return;
          this.cards = Array.from(all.values());
          this.cards.forEach((card,index) => card.dataset.order = index);
          this.brand = ''; this.page = 1;
          this.buildPills();
          this.querySelectorAll('[data-cstm-controls],[data-cstm-pills]').forEach(node => node.hidden = !this.cards.length);
          this.status.hidden = true;
          this.apply();
        } catch(error) {
          if (error.name !== 'AbortError' && this.isConnected && this.controller === controller) {
            this.status.textContent = this.dataset.errorText;
            this.querySelector('[data-cstm-retry]').hidden = false;
          }
        } finally {if (this.controller === controller) {this.loading = false; this.removeAttribute('aria-busy');}}
      }
      buildPills() {
        const counts = new Map();
        this.cards.forEach(card => {if (card.dataset.brand) counts.set(card.dataset.brand,(counts.get(card.dataset.brand) || 0) + 1);});
        const wrapper = this.querySelector('[data-cstm-pills]');
        wrapper.replaceChildren();
        const create = (label,key,count) => {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'cstm-bf-products__pill';
          button.dataset.cstmBrand = key;
          button.textContent = `${label} (${count})`;
          button.setAttribute('aria-pressed',String(this.brand === key)); wrapper.append(button);
        };
        create(this.dataset.allLabel,'',this.cards.length);
        [...counts].sort((a,b) => b[1]-a[1] || a[0].localeCompare(b[0])).forEach(([key,count]) => create(key,key,count));
      }
      apply(scroll = false) {
        if (!this.cards) return;
        const sort = this.querySelector('[data-cstm-sort]').value;
        const cards = this.cards.filter(card => !this.brand || card.dataset.brand === this.brand);
        cards.sort((a,b) => {
          if (sort === 'price-asc') return Number(a.dataset.price)-Number(b.dataset.price);
          if (sort === 'price-desc') return Number(b.dataset.price)-Number(a.dataset.price);
          if (sort === 'discount') return Number(b.dataset.discount)-Number(a.dataset.discount) || Number(a.dataset.order)-Number(b.dataset.order);
          if (sort === 'title') return a.dataset.title.localeCompare(b.dataset.title);
          return Number(a.dataset.order)-Number(b.dataset.order);
        });
        const size = Number(this.dataset.pageSize);
        const pages = Math.max(1,Math.ceil(cards.length/size));
        this.page = Math.max(1,Math.min(pages,this.page));
        this.grid.replaceChildren(...cards.slice((this.page-1)*size,this.page*size));
        this.querySelector('[data-cstm-count]').textContent = cards.length;
        this.querySelector('[data-cstm-offer-label]').textContent = cards.length === 1 ? this.dataset.offerSingular : this.dataset.offerLabel;
        this.querySelector('[data-cstm-empty]').hidden = cards.length > 0;
        this.querySelector('[data-cstm-pagination]').hidden = pages <= 1;
        this.querySelector('[data-cstm-page-label]').textContent = `${this.page} / ${pages}`;
        this.querySelector('[data-cstm-prev]').disabled = this.page <= 1;
        this.querySelector('[data-cstm-next]').disabled = this.page >= pages;
        this.querySelectorAll('[data-cstm-brand]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.cstmBrand === this.brand)));
        if (scroll) this.querySelector('.cstm-bf-products__head').scrollIntoView({block:'start',behavior:'instant'});
      }
      async add(form) {
        const button = form.querySelector('button');
        if (button.disabled) return;
        const card = form.closest('[data-cstm-card]');
        const errorNode = card.querySelector('[data-cstm-add-error]');
        errorNode.hidden = true;
        button.disabled = true; button.setAttribute('aria-busy','true');
        let added = false;
        try {
          const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const body = new FormData(form);
          const hasAdapter = typeof drawer?.getSectionsToRender === 'function' && typeof drawer?.renderContents === 'function';
          if (hasAdapter) {
            body.set('sections',drawer.getSectionsToRender().map(s => s.id).join(','));
            body.set('sections_url',location.pathname); drawer.setActiveElement?.(button);
          }
          const response = await fetch(this.dataset.addUrl + '.js', {method:'POST',body,headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},credentials:'same-origin'});
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.errorText);
          added = true;
          if (!hasAdapter) {location.assign(this.dataset.cartUrl); return;}
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'cstm-bf-products',productVariantId:body.get('id'),cartData:data});
          this.dispatchEvent(new CustomEvent('cstm-bf:cart-add',{bubbles:true,detail:{variantId:body.get('id')}}));
          try {
            const fresh = await this.fetchPage(card.dataset.sourceUrl);
            const replacement = [...fresh.querySelectorAll('[data-cstm-card]')].find(node => node.dataset.id === card.dataset.id);
            if (replacement && this.isConnected) {
              replacement.dataset.order = card.dataset.order; replacement.dataset.sourceUrl = card.dataset.sourceUrl;
              const i = this.cards.indexOf(card); this.cards[i] = replacement;
              if (card.isConnected) card.replaceWith(replacement);
            }
          } catch (_) {}
        } catch(error) {
          if (added) {location.assign(this.dataset.cartUrl); return;}
          errorNode.textContent = error.message; errorNode.hidden = false;
        } finally {button.disabled = false; button.removeAttribute('aria-busy');}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Presentation only: keep Swym's launcher, counter and event handlers intact.
  if (!customElements.get('cstm-header-action-label')) {
    class CstmHeaderActionLabel extends HTMLElement {
      connectedCallback() {
        this.cstmRoot = this.closest('.header__icons');
        if (!this.cstmRoot) return;
        this.cstmSync = () => {
          const launcher = this.cstmRoot.querySelector('#swym-advanced-header-icon');
          if (!launcher) return;
          if (!launcher.querySelector('.cstm-header-favorites-label')) {
            const label = document.createElement('span');
            label.className = 'cstm-header-favorites-label';
            label.textContent = this.dataset.label || 'Favoris';
            launcher.appendChild(label);
          }
        };
        this.cstmObserver = new MutationObserver(this.cstmSync);
        this.cstmObserver.observe(this.cstmRoot, { childList: true, subtree: true });
        this.cstmSync();
      }

      disconnectedCallback() {
        this.cstmObserver?.disconnect();
      }
    }
    customElements.define('cstm-header-action-label', CstmHeaderActionLabel);
  }

  } catch(e) { console.error(e); }
})();
})();
